// 💾 src/pages/admin/AdminLogin.tsx
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { signInWithEmailAndPassword } from "firebase/auth"
import { doc, getDoc } from "firebase/firestore"
import { auth, db } from "../../services/firebase"
import { toast } from "react-toastify"

const AdminLogin: React.FC = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      const { user } = await signInWithEmailAndPassword(auth, email, password)

      // Fetch role from Firestore
      const snap = await getDoc(doc(db, "users", user.uid))
      if (!snap.exists()) throw new Error("User profile not found")

      const data = snap.data()
      if (data.role !== "Admin") {
        toast.error("You are not authorized as admin")
        setLoading(false)
        return
      }

      toast.success("Welcome back, Admin!")
      navigate("/admin/dashboard", { replace: true })
    } catch (err: any) {
      console.error("❌ Admin login failed", err)
      toast.error(err.message || "Login failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ maxWidth: 400, margin: "50px auto" }}>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
        </div>
        <div>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  )
}

export default AdminLogin
